import { render, staticRenderFns } from "./NewAlertPersonalSet.vue?vue&type=template&id=54003128&scoped=true"
import script from "./NewAlertPersonalSet.vue?vue&type=script&lang=js"
export * from "./NewAlertPersonalSet.vue?vue&type=script&lang=js"
import style0 from "./NewAlertPersonalSet.vue?vue&type=style&index=0&id=54003128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54003128",
  null
  
)

export default component.exports